import { RouteRecordRaw } from 'vue-router';

const Layout = () => import('@/layout/index.vue');
const newsRouter:RouteRecordRaw =  {
    path: '/news',
    component: Layout,
    name: 'news',
    children: [
        {
            path: '',
            name: 'news-index', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/news/index.vue'),
            meta: {
                title: '新闻资讯'
            }
        },
        {
            path: 'detail/:id',
            name: 'news-detail', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/news/detail.vue'),
            meta: {
                title: ''
            }
        }
    ]
};

export default newsRouter;
